export default "__VITE_ASSET__BIK2KKzl__"